import { styled } from "@mui/material";
import { loginLayoutName } from "../classes.js";
const doNotForward = ["ownerState", "maxHeight"];
const Header = styled("div", {
  name: loginLayoutName,
  slot: "Header",
  overridesResolver: (_, styles) => styles.header,
  shouldForwardProp: (prop) => !doNotForward.includes(prop)
})(({ maxHeight }) => ({
  top: 0,
  left: 0,
  width: "100%",
  position: "absolute",
  maxeight: maxHeight
}));
export {
  Header
};
//# sourceMappingURL=Header.js.map
